import { render } from "./FrameCard.vue?vue&type=template&id=77f13304"
import script from "./FrameCard.vue?vue&type=script&lang=js"
export * from "./FrameCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__